import { useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import { setAuthTokenProvider } from '../api/client';
import TopNav from '../components/TopNav';
import ProfileForm from '../components/ProfileForm';
import ChangePasswordForm from '../components/ChangePasswordForm';
import DeveloperApiSection from '../components/DeveloperApiSection';
import DeleteAccountSection from '../components/DeleteAccountSection';
import { detectProvider } from '../utils/auth-utils';

export default function SettingsPage() {
  const { user, signOut, getAccessToken, isAdmin, email: authEmail } = useAuth();
  const email = authEmail || user?.signInDetails?.loginId || '';

  const provider = detectProvider(user?.username);
  const isOAuthUser = provider !== 'email';

  useEffect(() => {
    setAuthTokenProvider(getAccessToken);
  }, [getAccessToken]);

  return (
    <>
      <TopNav
        email={email}
        provider={provider}
        isAdmin={isAdmin}
        onSignOut={() => void signOut()}
      />

      <div className="settings">
        <h1 className="settings-title">Settings</h1>
        <p className="settings-subtitle">Manage your profile and account.</p>

        <div className="card settings-card">
          <h2>Profile</h2>
          <ProfileForm email={email} />
        </div>

        <div className="card settings-card">
          <h2>Security</h2>
          <ChangePasswordForm isOAuthUser={isOAuthUser} />
        </div>

        <div className="card settings-card">
          <h2>Developer API</h2>
          <DeveloperApiSection />
        </div>

        <div className="card settings-card settings-card-danger">
          <h2>Delete Account</h2>
          <DeleteAccountSection onSignOut={signOut} />
        </div>
      </div>
    </>
  );
}
